import React, { useEffect, useRef, useState } from "react";
import View from "../ReactNative/View";
import InViewModal from "../InViewModal/InViewModal";
import User from "../../data/user/User";
import AppTheme from "../../utils/Theme";
import Style from "../../utils/Style";
import Text from "../ReactNative/Text";
import Divider from "../../designSystem/Divider/Divider";
import Button from "../../designSystem/Button";
import i18n, { getLanguage } from "../../utils/Localization/Localization";
import { LaunchStep } from "../../models/Models";
import { getLocalintegrationSteps } from "../../../specific/utils/LocalStorage";
import { Image, Platform, ScrollView, TouchableOpacity, ViewStyle } from "react-native";
import UserLevelSelection from "../Filters/UserLevelSelection";
import Modal from "../../../specific/components/Modal/Modal";
import { PDFDocument } from "./SuperRoom";
import { AppTarget, getAppTarget } from "../../../specific/utils/Navigation/Host";
import { getDocumentUrlForMediaId } from "../../../specific/services/AppWrite/AppWriteDatabase";
import { openUrl } from "../../utils/WebLink";
import { iconBySteps, ScreenActivitySheet } from "../../utils/Constants";
import Images from "../../../specific/utils/Images";
import SVGView from "../../utils/SvgView";
import { IcCheck, IcClose } from "../../utils/Icons";
import { MatrixLocalizedString } from "../../screens/rooms/FamilyRoom";
import DocumentsViewer from "../Documents/DocumentsViewer";
import PDFViewer from "../../../specific/components/PDF/PDFViewer";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";
import RoundIconButton from "../../designSystem/RoundIconButton";
import NavBarButton from "../NavBar/NavBarButton";

interface StartingStepsModalProps {
    onCloseRequest: () => void;
    componentId: string;
    navigate: string;
    illustration?: number | { uri: string };
    illustrationRatio?: { w: number, h: number };
    title?: MatrixLocalizedString;
}

const StartingStepsModal = (props: StartingStepsModalProps) => {

    const { onCloseRequest, componentId, navigate, illustration, illustrationRatio, title } = props;

    const user: User = User.getInstance();
    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();
    const inViewModal = useRef<InViewModal>(null);

    const [launchSteps, setLaunchSteps] = useState<LaunchStep[] | undefined>(undefined);
    const [pdfDocumentToShow, setPdfDocumentToShow] = useState<PDFDocument | undefined>(undefined);
    const [documentIdToShow, setDocumentIdToShow] = useState<string | undefined>(undefined);
    const [showFilters, setShowFilters] = useState<boolean>(false);
    const [resfreshView, setRefreshView] = useState<number>(0);

    const {
        fullScreenWidth,
        fullScreenHeight,
        availableScreenSize,
        contentSize,
        sideMenuSize,
        horizontalSpacing
    } = useSpecificSize();

    // UI Définition
    let backgroundColor: string = appTheme.parentBackgroundColor;
    let stepsColor = appTheme.homeColor;
    let stepsTitleColor = appTheme.darkBlue;
    let macaroonImage = images.icParentMacaroon;
    let itemsColor: string = appTheme.homeColor;
    let itemsTextColor: string = appTheme.darkBlue;
    if (user.profile === "teacher") {
        stepsColor = "#716899";
        stepsTitleColor = "#FFFFFF";
        backgroundColor = appTheme.teacherBackgroundColor;
        macaroonImage = images.icTeacherMacaroon;
        itemsColor = appTheme.schoolColor;
        itemsTextColor = appTheme.white;
    } else if (user.profile === "animator") {
        stepsColor = appTheme.schoolColor;
        stepsTitleColor = "#FFFFFF";
        backgroundColor = appTheme.animatorBackgroundColor;
        macaroonImage = images.icTeacherMacaroon;
        itemsColor = appTheme.schoolColor;
        itemsTextColor = appTheme.white;
    }

    useEffect(() => {
        if (launchSteps === undefined) {
            getStepsData();
        }
    }, [launchSteps]);

    const getStepsData = async () => {
        const localLaunchSteps = await getLocalintegrationSteps();
        const localLaunchStepsData = localLaunchSteps.data;
        let updatedLaunchStepsByTarget: LaunchStep[] = [];
        for (const aLocalLaunchStepKey in localLaunchStepsData) {
            if (Object.prototype.hasOwnProperty.call(localLaunchStepsData, aLocalLaunchStepKey)) {
                let aLaunchStep: LaunchStep = localLaunchStepsData[aLocalLaunchStepKey];
                if ((aLaunchStep.target.indexOf(user.profile) !== -1) || ((Platform.OS === "web") && (aLaunchStep.target.indexOf(`web_${user.profile}`) !== -1))) {
                    // On va regarder où le ranger en fonction de l'ordre d'affichage défini en base
                    let launchStepInserted: boolean = false;
                    if (aLaunchStep.order_by_target[user.profile] !== undefined) {
                        for (const anOrderedIndex in updatedLaunchStepsByTarget) {
                            if (Object.prototype.hasOwnProperty.call(updatedLaunchStepsByTarget, anOrderedIndex)) {
                                const anOrderedLaunchStep: LaunchStep = updatedLaunchStepsByTarget[anOrderedIndex];
                                if (anOrderedLaunchStep.order_by_target[user.profile] !== undefined) {
                                    if (aLaunchStep.order_by_target[user.profile] < anOrderedLaunchStep.order_by_target[user.profile]) {
                                        updatedLaunchStepsByTarget.splice(parseInt(anOrderedIndex), 0, aLaunchStep);
                                        launchStepInserted = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    if (launchStepInserted === false) {
                        updatedLaunchStepsByTarget.push(aLaunchStep);
                    }
                }
            }
        }
        setLaunchSteps(updatedLaunchStepsByTarget);
    }

    const onCellRequest = async (request: LaunchStep, backgroundColor?: string) => {
        const appTarget: AppTarget = getAppTarget();
        let color: string = appTheme.schoolColor;
        if (user.profile === "family") {
            color = appTheme.homeColor;
        }
        if (backgroundColor === undefined) {
            backgroundColor = color;
        }
        if (request.action.type === "doc") {
            setDocumentIdToShow(request.action.urls[user.profile][getLanguage()]);
        } else if (request.action.type === "pdf") {
            let pdfUrl: string | undefined = undefined;
            let pdfTitle: string = "Lili";
            if (request.action.url !== undefined) {
                pdfUrl = request.action.url[getLanguage()];
            } else if ((request.action.urls !== undefined) && (request.action.urls[user.profile] !== undefined)) {
                pdfUrl = request.action.urls[user.profile][getLanguage()];
            }
            if ((appTarget !== "public") && (request.action.id !== undefined)) {
                pdfUrl = getDocumentUrlForMediaId({ media_id: request.action.id });
            }
            if ((request.action.title !== undefined) && (request.action.title[getLanguage()] !== undefined)) {
                pdfTitle = request.action.title[getLanguage()];
            } else if ((request.action.titles !== undefined) && (request.action.titles[user.profile] !== undefined) && (request.action.titles[user.profile][getLanguage()] !== undefined)) {
                pdfTitle = request.action.titles[user.profile][getLanguage()];
            }
            if ((pdfUrl !== undefined) && (pdfUrl.length > 0)) {
                setPdfDocumentToShow({
                    title: pdfTitle,
                    url: pdfUrl,
                    color
                });
            }
        } else if (request.action.type === "show_filters") {
            setTimeout(() => {
                setShowFilters(true);
            }, 500);
        } else if (request.action.type === "link") {
            if ((request.action.url !== undefined) && (request.action.url[getLanguage()] !== undefined)) {
                openUrl(request.action.url[getLanguage()]);
            } else if ((request.action.urls !== undefined) && (request.action.urls[user.profile] !== undefined) && (request.action.urls[user.profile][getLanguage()] !== undefined)) {
                openUrl(request.action.urls[user.profile][getLanguage()]);
            }
        } else if (request.action.type === "activity") {
            const passProps = {
                activityKey: request.action.activity_key,
                categoryKey: request.action.category_key,
                sectionKey: request.action.section_key,
                context: user.profile,
                isModal: true
            };
            if (Platform.OS === "web") {
                inViewModal.current?.showAlert({
                    name: ScreenActivitySheet,
                    passProps
                });
            } else {
                Navigation.showModal({
                    componentId,
                    navigate,
                    passProps,
                    name: ScreenActivitySheet
                })
            }
        }
        if (user.steps !== undefined) {
            if ((user.steps[request.id] === undefined) || ((user.steps[request.id] !== undefined) && (user.steps[request.id] === false))) {
                let userSteps = user.steps;
                userSteps[request.id] = true;
                await addDataToUser({ key: "steps", value: userSteps, user_id: user.uid });
                setRefreshView(new Date().getTime());
            }
        }
    }

    const showStepAction = async (step: LaunchStep) => {
        if (step.hide_steps === true) {
            onCloseRequest();
        }
        onCellRequest(step, backgroundColor);
    }

    const stepCell = (data: { step: LaunchStep, isFirst: boolean, isLast: boolean }) => {
        const { step } = data;
        let isStepChecked = false;
        if (user.steps !== undefined) {
            if (user.steps[step.id] !== undefined) {
                isStepChecked = user.steps[step.id];
            }
        }
        let stepImage: number | { uri: string } = step.icon !== undefined ? images[step.icon] : step.icon_id !== undefined ? iconBySteps[step.icon_id] : iconBySteps[step.icons_id[user.profile]];
        if (step.id === "notice") {
            stepImage = images.illStepNotice;
        }
        const playButtonSize = Platform.OS === "web" ? appTheme.pixelPerfect(42) : appTheme.pixelPerfect(34);
        const lineHeight = Platform.OS === "web" ? appTheme.pixelPerfect(10) : appTheme.pixelPerfect(5);
        const actionButtonBackgroundColor = isStepChecked === false ? appTheme.white : stepsColor;
        const actionButtonTextColor = isStepChecked === true ? stepsTitleColor : appTheme.darkBlue;
        const mediaCellWidth = Platform.OS === "web" ? appTheme.getBlockWidth() : appTheme.getFullAppWidth();
        const checkView = isStepChecked === false ? <View style={{ width: playButtonSize }} /> : <View style={{ width: playButtonSize, justifyContent: "center", alignItems: "center" }}><SVGView Component={IcCheck} color={actionButtonTextColor} size={14} /></View>;
        let stepTitle: string = "";
        if ((step.title !== undefined) && (step.title[getLanguage()] !== undefined)) {
            stepTitle = step.title[getLanguage()];
        } else if ((step.titles !== undefined) && (step.titles[user.profile] !== undefined) && (step.titles[user.profile][getLanguage()] !== undefined)) {
            stepTitle = step.titles[user.profile][getLanguage()];
        }
        return <TouchableOpacity onPress={() => showStepAction(step)} style={{ backgroundColor: appTheme.white, flexDirection: "row", height: appTheme.pixelPerfect(45) + lineHeight, justifyContent: "flex-start", alignItems: "center", width: appTheme.getFlexDirectionForSplitScreen() === "row" ? mediaCellWidth * 0.6 : mediaCellWidth * 0.9 }}>
            <View style={{ borderWidth: appTheme.pixelPerfect(0.5), borderColor: stepsColor + "4D", borderRadius: (playButtonSize + appTheme.pixelPerfect(6)) / 2, backgroundColor: actionButtonBackgroundColor, flexDirection: "row", height: playButtonSize + appTheme.pixelPerfect(6), justifyContent: "flex-start", alignItems: "center", paddingHorizontal: appTheme.pixelPerfect(2), width: appTheme.getFlexDirectionForSplitScreen() === "row" ? mediaCellWidth * 0.6 : mediaCellWidth * 0.9 }}>
                <View style={{ borderWidth: 1, borderColor: appTheme.darkBlue, width: playButtonSize, height: playButtonSize, borderRadius: playButtonSize / 2, justifyContent: "center", alignItems: "center", backgroundColor: actionButtonBackgroundColor, marginEnd: appTheme.pixelPerfect(10) }}>
                    <Image source={stepImage} style={{ width: playButtonSize, height: playButtonSize, borderRadius: playButtonSize / 2 }} />
                </View>
                <Text numberOfLines={3} style={{ color: actionButtonTextColor, flex: 1, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(8) }}>
                    {stepTitle}
                </Text>
                {checkView}
            </View>
        </TouchableOpacity>
    }

    const renderStepList = () => {
        let stepListView = [];
        for (const aStepIndex: string in launchSteps) {
            if (Object.prototype.hasOwnProperty.call(launchSteps, aStepIndex)) {
                const aStep: LaunchStep = launchSteps[parseInt(aStepIndex)];
                stepListView.push(stepCell({
                    step: aStep,
                    isFirst: parseInt(aStepIndex) === 0,
                    isLast: parseInt(aStepIndex) === launchSteps.length - 1,
                }))
            }
        }
        return stepListView
    }

    const renderIllustration = (): React.JSX.Element | null => {
        if (illustration !== undefined) {
            const illuWidth: number = Platform.OS === "web" ? contentSize * 0.6 : appTheme.getBlockWidth();
            let illuHeight: number = illuWidth;
            if (illustrationRatio !== undefined) {
                illuHeight = illuWidth * illustrationRatio.h / illustrationRatio.w;
            }
            return <Image source={illustration} style={{ width: illuWidth, height: illuHeight }} resizeMode="contain" />
        }
        return null;
    }

    const renderSteps = () => {
        let modalTitle: string = "Comment intégrer Lili dans le temps de classe ?";
        if (user.profile === "animator") {
            modalTitle = "Comment utiliser Lili en périscolaire ?";
        } else if (user.profile === "family") {
            modalTitle = "Comment utiliser Lili à la maison ?";
        }
        if (Platform.OS === "web") {
            return <View style={{ width: contentSize, height: fullScreenHeight, justifyContent: "flex-end" }}>
                <View style={[Style.shadowed, { backgroundColor: appTheme.white, borderTopEndRadius: appTheme.pixelPerfect(20), borderTopStartRadius: appTheme.pixelPerfect(20), paddingTop: appTheme.pixelPerfect(40), paddingBottom: appTheme.pixelPerfect(40), alignItems: "center" }]}>
                    <Text style={{ textAlign: "center", textTransform: "uppercase", fontFamily: appTheme.primaryBoldFont, color: appTheme.darkBlue, fontSize: appTheme.pixelPerfectForFont(7) }}>
                        {modalTitle}
                    </Text>
                    <Divider />
                    {renderIllustration()}
                    {renderStepList()}
                    <Divider />
                    <View style={{ position: "absolute", top: 10, right:10}}>
                    <NavBarButton icon={IcClose} action={onCloseRequest} />
                    </View>
                </View>
            </View>
        }
        return <ScrollView style={{ flex: 1 }}>
            <View style={{ width: contentSize, height: fullScreenHeight, flex: 1, justifyContent: "flex-end" }}>
                <View style={[Style.shadowed, { backgroundColor: appTheme.white, borderTopEndRadius: appTheme.pixelPerfect(20), borderTopStartRadius: appTheme.pixelPerfect(20), paddingTop: appTheme.pixelPerfect(40), paddingBottom: appTheme.pixelPerfect(40), alignItems: "center" }]}>
                    <Text style={{ textAlign: "center", textTransform: "uppercase", fontFamily: appTheme.primaryBoldFont, color: appTheme.darkBlue, fontSize: appTheme.pixelPerfectForFont(7) }}>
                        {modalTitle}
                    </Text>
                    <Divider />
                    {renderIllustration()}
                    {renderStepList()}
                    <Divider />
                    <View style={{ position: "absolute", top: 10, right:10}}>
                    <NavBarButton icon={IcClose} action={onCloseRequest} />
                    </View>
                </View>
            </View>
        </ScrollView>
    }

    const renderDocViewer = (): React.JSX.Element | null => {
        if (documentIdToShow === undefined) {
            return null;
        }
        return <DocumentsViewer
            documentId={documentIdToShow}
            onDocumentCloseRequest={() => setDocumentIdToShow(undefined)} />;
    }

    const renderPDFViewer = (): React.JSX.Element | null => {
        if (pdfDocumentToShow === undefined) {
            return null;
        }
        return <PDFViewer
            title={pdfDocumentToShow.title}
            pdfUrl={pdfDocumentToShow.url}
            color={pdfDocumentToShow.color}
            closeTheDocument={() => setPdfDocumentToShow(undefined)} />
    }

    let mainViewStyle: ViewStyle = {
        width: fullScreenWidth, backgroundColor: "#FFFFFFCC", alignItems: "center", paddingLeft: Platform.OS === "web" ? sideMenuSize : 0
    }
    if (Platform.OS !== "web") {
        mainViewStyle.height = fullScreenHeight;
    }

    return <View style={mainViewStyle}>
        {renderSteps()}
        <UserLevelSelection
            visible={showFilters}
            style={{ flex: 1, justifyContent: "flex-end" }}
            backgroundColor={itemsColor}
            toggleFilters={() => setShowFilters(prev => !prev)} />
        <Modal animationType="slide" visible={documentIdToShow !== undefined} transparent={true} style={{ width: appTheme.getFullScreenWidth() }}>
            <View style={{ flex: 1, alignItems: "center", backgroundColor: backgroundColor + "80", width: appTheme.getFullScreenWidth() }}>
                <View style={{ flex: 1, justifyContent: "flex-end", backgroundColor: backgroundColor + "80", width: appTheme.getFullAppWidth() }}>
                    {renderDocViewer()}
                </View>
            </View>
        </Modal>
        <Modal animationType="slide" visible={pdfDocumentToShow !== undefined} transparent={true} style={{ width: appTheme.getFullScreenWidth() }}>
            <View style={{ flex: 1, alignItems: "center", backgroundColor: backgroundColor + "80", width: appTheme.getFullScreenWidth() }}>
                <View style={{ flex: 1, justifyContent: "flex-end", backgroundColor: backgroundColor + "80", width: appTheme.getFullAppWidth() }}>
                    {renderPDFViewer()}
                </View>
            </View>
        </Modal>
    </View>
}

export default StartingStepsModal;